import moment from 'moment';
import 'moment/locale/ko';
import { useEffect, useState } from 'react';
import { useDaumPostcodePopup } from 'react-daum-postcode';
import { Link, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import FormatPhoneNumber from '../../../shared/components/FormatPhoneNumber';
import {
    deleteMABAA030Block,
    deleteMABAA070Block,
    getMABAA030,
    getMABAA030Block,
    getMABAA030Comments,
    getMABAA070Block,
    postMABAA030Block,
    postMABAA030Comment,
    postMABAA030Leave,
    postMABAA031,
    postMABAA070Block,
    postMABAA070Leave,
    putMABAA030,
    putMABAA030Bcs,
    putMABAA030Sms,
    putMABAA030VitaminLetter,
    putMABAA031ResetPassword,
    putMABAA031ResetStatus,
    putMABAA070Bcs,
    putMABAA070Sms,
    putMABAA070VitaminLetter,
} from '../../../services/Api';
import { MESSAGE } from '../../../shared/constants/app';
import { formatDate, formatBizNo } from '../../../utils';

const MABAA031 = () => {
    const navigate = useNavigate();
    const [data, setData] = useState({});
    const [isBlock, setIsBlock] = useState(false);
    const [dataComments, setDataComments] = useState([]);
    const [reasonValue, setReasonValue] = useState('');
    const { id } = useParams();
    const [isPopupVisible, setIsPopupVisile] = useState(false);
    const [isInputReason, setIsInputReason] = useState(true);
    const [payload, setPayload] = useState({});

    const [searchParams] = useSearchParams();
    const tbl = searchParams.get('tbl');
    const memberGbn = searchParams.get('gbn');

    const openPostcodePopup = useDaumPostcodePopup();

    const handleComplete = (data) => {
        const { address, zonecode: postNo, roadAddress: addressRoad, bname: addressExtra } = data;
        setData((prevData) => ({ ...prevData, postNo, addressRoad, addressExtra, address }));
    };

    const { pathname } = useLocation();
    const [residentNoDisplay, setResidentNoDisplay] = useState('');
    const pathKey = pathname.split('/')[1].split('-')[0];

    const navigator = useNavigate();

    function getSiteNameSwitch(regSiteGbn) {
        switch (regSiteGbn) {
            case 'dj':
                return '덴탈잡';
            case 'ds':
                return '덴탈세미나';
            case 'dv':
                return '덴탈비타민';
            case 'em':
                return 'DVmall';
            default:
                return regSiteGbn;
        }
    }

    const fetchData = async () => {
        try {
            let dataBlock;
            const { data: memberData } = await getMABAA030(id, tbl, memberGbn);
            const member = memberData.member;
            setData(member);
            const { data: commentsData } = await getMABAA030Comments(member.memberId);
            setDataComments(commentsData);
            if (pathKey === 'MABAA031') {
                if (member?.memberId) {
                    const response = await getMABAA030Block(member.memberId);
                    dataBlock = response.data;
                }
            } else {
                if (member?.memberId) {
                    const response = await getMABAA070Block(member.memberId);
                    dataBlock = response.data;
                }
            }
            setIsBlock(dataBlock === '' ? 0 : 1);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line
    }, [id]);

    const handleClose = () => {
        setIsPopupVisile(false);
    };

    const handleOpen = () => {
        setIsPopupVisile(true);
        setReasonValue('');
    };

    const handleChangeReason = (e) => {
        const value = e.target.value;
        setReasonValue(value);
    };

    const handleBlock = (memberId) => {
        if (pathKey === 'MABAA031') {
            if (isBlock) {
                deleteMABAA030Block(memberId);
                setIsBlock(false);
            } else {
                postMABAA030Block(memberId);
                setIsBlock(true);
            }
        } else {
            if (isBlock) {
                deleteMABAA070Block(memberId);
                setIsBlock(false);
            } else {
                postMABAA070Block(memberId);
                setIsBlock(true);
            }
        }
        window.alert(MESSAGE.notify.updateSuccess);
    };

    const handleSearchAddress = () => {
        openPostcodePopup({
            onComplete: handleComplete,
            popupTitle: '델탈잡 채용광고 지도',
        });
    };

    // const lastLoginSite = {
    //     DJ: '덴탈잡',
    //     DA: '덴탈알바',
    //     DS: '덴탈세미나',
    //     DV: '덴탈비타민',
    //     EM: 'DVmall',
    // };

    const handleUpdateVitaminLetter = () => {
        handleUpdate('vitaminLetter', putMABAA030VitaminLetter, putMABAA070VitaminLetter, {
            message: {
                confirmY: '덴탈비타민 메일 수신여부가 변경하시겠습니까?',
                successY: '덴탈비타민 메일 수신여부가 변경되었습니다.',
                confirmN: '덴탈비타민 메일 수신여부가 변경하시겠습니까?',
                successN: '덴탈비타민 메일 수신여부가 변경되었습니다.',
            },
        });
    };

    const handleUpdateSMSSrv = () => {
        handleUpdate('smsSrv', putMABAA030Sms, putMABAA070Sms, {
            message: {
                confirmY: 'SMS 수신여부가 변경하시겠습니까?',
                successY: 'SMS 수신여부가 변경되었습니다.',
                confirmN: 'SMS 수신여부가 변경하시겠습니까?',
                successN: 'SMS 수신여부가 변경되었습니다.',
            },
        });
    };

    const handleUpdateBcsSelYN = () => {
        handleUpdate('bcsSelYN', putMABAA030Bcs, putMABAA070Bcs, {
            message: {
                confirmY: '해당회원을 우수회원으로 선정하시겠습니까?',
                successY: '우수회원으로 선정되었습니다.',
                confirmN: '해당회원을 우수회원에서 제외시키시겠습니까?',
                successN: '우수회원에서 제외되었습니다.',
            },
        });
    };

    const handleUpdate = (field, apiCall030, apiCall070, { message }) => {
        const currentValue = data[field];
        const confirmMessage = currentValue === 'Y' ? message.confirmY : message.confirmN;
        const successMessage = currentValue === 'Y' ? message.successY : message.successN;
        const isConfirmed = window.confirm(confirmMessage);
        if (isConfirmed) {
            const apiCall = id ? apiCall030 : apiCall070;
            const payload = {
                seq: id,
                [field]: currentValue === 'Y' ? 'N' : 'Y',
            };
            apiCall(payload[field], id)
                .then(() => {
                    window.alert(successMessage);
                    setData((prevData) => ({
                        ...prevData,
                        [field]: payload[field],
                    }));
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        let processedValue;

        if (name === 'mobileNo' || name === 'telNo') {
            processedValue = FormatPhoneNumber(value);
        } else if (name === 'bizNo') {
            processedValue = formatBizNo(value);
        } else if (name === 'residentNo') {
            // 표시값은 그대로, data에는 dot 제거한 값 저장
            setResidentNoDisplay(value);
            setData((prevData) => ({ ...prevData, residentNo: value.replace(/\./g, '') }));
            return;
        } else {
            processedValue = value;
        }

        setData((prevData) => ({
            ...prevData,
            [name]: processedValue,
        }));
    };

    const handleSaveLeave = () => {
        const dataLeave = {
            memberID: data.memberId,
            leaveSite: data.lastLoginSite,
            leaveReason: reasonValue,
            leaveType: 'ADMIN',
        };
        const isConfirmed = id ? window.confirm(MESSAGE.confirm.create) : '';
        if (isConfirmed) {
            if (pathKey === 'MABAA031') {
                postMABAA030Leave(dataLeave);
            } else {
                postMABAA070Leave(dataLeave);
            }
            window.alert(MESSAGE.notify.createSuccess);
            setIsInputReason(false);
        }
    };
    const handleSave = () => {
        const payload = {
            seq: id,
            nameKor: data.nameKor,
            bizCompany: data.bizCompany,
            postNo: data.postNo,
            addressRoad: data.addressRoad,
            addressDetail: data.addressDetail,
            email: data.email,
            mobileNo: data.mobileNo,
            telNo: data.telNo,
            memberGbn: data.memberGbn,
            appGbnCD: data.appGbnCd,
            bizNo: data.bizNo,
            licenseNo: data.licenseNo,
            residentNo: data.residentNo
                ? moment(data.residentNo.replace(/\./g, ''), 'YYYYMMDD').format('YYMMDD')
                : '',
            tbl,
        };

        if (window.confirm('저장하시겠습니까?')) {
            putMABAA030(payload)
                .then(() => {
                    window.alert('업데이트 완료되었습니다.');
                    setData((prevData) => ({
                        ...prevData,
                        ...payload,
                    }));
                    data.memberGbn === 'P'
                        ? navigator(`/mabaa030-${id}?tbl=${tbl}&gbn=${memberGbn}`)
                        : navigator(`/mabaa070-${id}?tbl=${tbl}&gbn=${memberGbn}`);
                })
                .catch((error) => {
                    console.log(error);
                    window.alert('오류발생했습니다.');
                });
        }
    };

    const handleResetPassword = () => {
        if (window.confirm('비밀번호 초기화하시겠습니까?')) {
            putMABAA031ResetPassword(data?.seq, tbl)
                .then(() => {
                    window.alert('비밀번호를 아이디와 동일하게 초기화되었습니다.');
                })
                .catch((error) => console.log(error));
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPayload((prevPayload) => ({
            ...prevPayload,
            [name]: value,
        }));
    };

    const handleSaveComment = () => {
        if (payload.comments === '') {
            alert('내용을 입력해 주세요.');
            return;
        }

        payload.memberID = data.memberId;
        payload.sitePos = 'DJ';

        postMABAA030Comment(payload)
            .then(() => {
                fetchData();
                alert('코멘트 등록되었습니다.');
            })
            .catch((error) => console.log(error));
    };
    const handleIntegrated = () => {
        const memberID = data?.memberId;
        const confirm = window.confirm(`덴탈비타민 ID ( ${memberID ? memberID : ''} ) 로 통합전환 하시겠습니까?`);
        if (confirm) {
            postMABAA031(data?.seq)
                .then((res) => {
                    window.alert('덴탈비타민 ID로 통합전환했습니다.');
                    navigate('/mabaa010');
                })
                .catch((error) => {
                    window.alert('이미 존재하는 통합회원 아이디입니다.');
                    console.log(error);
                });
        }
    };

    const handleResetStatus = () => {
        console.log(data);

        const confirm = window.confirm(`휴면계정을 활성계정으로 전환하시겠습니까?`);
        if (confirm) {
            putMABAA031ResetStatus(data?.seq)
                .then(() => {
                    window.alert('활성전환이 완료되었습니다.');
                    window.location.reload();
                })
                .catch((error) => {
                    window.alert('오류 발생했습니다.');
                    console.log(error);
                });
        }
    };
    return (
        <div className="profile-content">
            <div className="title-profile">회원 기본정보</div>
            <div className="group-action">
                <button className="action-block" onClick={() => handleBlock(data.memberId)}>
                    {isBlock ? '차단해제' : '차단등록'}
                </button>
                <button className="action-reason" onClick={() => handleOpen()}>
                    탈퇴
                </button>
            </div>

            <div className="member-basic-infor">
                <div className="title-table-info">개인 정보</div>
                <table className="table member-infor">
                    <tbody>
                        <tr>
                            <th>
                                <span>회원상태</span>
                            </th>
                            <td className="border-r-ddd">
                                {data.memberStatus !== '' ? '활성' : '휴면'}
                                {data.memberStatus === '' && (
                                    <button
                                        className="pick-address"
                                        style={{ marginLeft: '18px' }}
                                        onClick={handleResetStatus}
                                    >
                                        휴면계정 활성전환(ID 통합 아님)
                                    </button>
                                )}
                            </td>
                            <th colSpan={2}>
                                <span>가입일</span>
                            </th>
                            <td>{formatDate(data.regDate)}</td>
                        </tr>
                        <tr>
                            <th>
                                <span>아이디</span>
                            </th>
                            <td className="border-r-ddd">{data.memberId}</td>
                            <th colSpan={2}>
                                <span>비밀번호</span>
                            </th>
                            <td>
                                <button className="btn btn-secondary" onClick={handleResetPassword}>
                                    아이디와 동일하게 초기화
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <span>이름</span>
                            </th>
                            <td className="border-r-ddd">
                                <input onChange={handleChange} type="text" name="nameKor" value={data.nameKor || ''} />
                            </td>
                            <th colSpan={2} className="border-t-ddd">
                                <span>생년월일</span>
                            </th>
                            <td className="border-t-ddd">
                                <input
                                    onChange={handleChange}
                                    type="text"
                                    name="residentNo"
                                    value={residentNoDisplay}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th rowSpan={3} style={{ verticalAlign: 'middle' }}>
                                <span>주소</span>
                            </th>
                            <td className="border-r-ddd">
                                <span style={{ marginRight: '15px' }}>
                                    ({' '}
                                    <input
                                        onChange={handleChange}
                                        type="text"
                                        name="postNo"
                                        value={data.postNo || ''}
                                        style={{ width: '80px' }}
                                        readOnly
                                    />{' '}
                                    )
                                </span>
                                <button className="pick-address" onClick={handleSearchAddress}>
                                    주소변경
                                </button>
                            </td>
                            <th colSpan={2}>
                                <span>이메일</span>
                            </th>
                            <td>
                                <input onChange={handleChange} type="text" name="email" value={data.email} />
                            </td>
                        </tr>
                        <tr>
                            <td className="border-r-ddd">
                                <input
                                    onChange={handleChange}
                                    type="text"
                                    name="addressRoad"
                                    value={data.addressRoad || ''}
                                    readOnly
                                />
                            </td>
                            <th colSpan={1} rowSpan={2} style={{ width: '80px', verticalAlign: 'middle' }}>
                                <span>연락처</span>
                            </th>
                            <th colSpan={1} rowSpan={1} style={{ width: '80px' }}>
                                유선
                            </th>
                            <td>
                                <input onChange={handleChange} type="text" name="telNo" value={data.telNo} />
                            </td>
                        </tr>
                        <tr>
                            <td className="border-r-ddd">
                                <input
                                    onChange={handleChange}
                                    type="text"
                                    name="addressDetail"
                                    value={data.addressDetail || ''}
                                />
                            </td>
                            <th colSpan={1} rowSpan={1} style={{ width: '80px' }}>
                                휴대폰
                            </th>
                            <td>
                                <input
                                    onChange={handleChange}
                                    type="text"
                                    name="mobileNo"
                                    value={data.mobileNo || ''}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <span>회원구분</span>
                            </th>
                            <td className="border-r-ddd">
                                <select name="appGbnCd" value={data.appGbnCd} onChange={handleChange}>
                                    <option value="110">치과의사</option>
                                    <option value="200">치과기공사</option>
                                    <option value="201">치과기공사(소장)</option>
                                    <option value="202">치과기공사(기사)</option>
                                    <option value="310">치과위생사 및 진료스텝</option>
                                    <option value="401">학생(치의학과)</option>
                                    <option value="402">학생(치위생사)</option>
                                    <option value="403">학생(치기공사)</option>
                                    <option value="999">기타</option>
                                </select>
                            </td>
                            <th colSpan={2}>
                                <span>근무처(소속)</span>
                            </th>
                            <td>
                                <input
                                    onChange={handleChange}
                                    type="text"
                                    name="bizCompany"
                                    value={data.bizCompany || ''}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <span>면허번호</span>
                            </th>
                            <td className="border-r-ddd border-b-ddd">
                                <input
                                    onChange={handleChange}
                                    type="text"
                                    name="licenseNo"
                                    value={data.licenseNo || ''}
                                />
                            </td>
                            <th colSpan={2}>
                                <span>덴탈잡그룹구분</span>
                            </th>
                            <td className="border-b-ddd">
                                <select name="memberGbn" value={data.memberGbn} onChange={handleChange}>
                                    <option value="P">개인회원</option>
                                    <option value="C">치과회원</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="membership-infor">
                <div className="title-table-info">멤버십 정보</div>
                <table className="table member-infor">
                    <tbody>
                        <tr>
                            <th className="border-t-ddd">
                                <span>통합여부</span>
                            </th>
                            <td colSpan={3}>미통합회원</td>
                        </tr>
                        <tr>
                            <th className="border-t-ddd">
                                <span>가입사이트</span>
                            </th>
                            <td className="border-r-ddd">{getSiteNameSwitch(data.regSiteGbn) || '-'}</td>
                            <th className="border-t-ddd">
                                <span>이용가능 사이트</span>
                            </th>
                            <td>덴탈잡</td>
                        </tr>
                        <tr>
                            <th>Dvmall ID</th>
                            <td colSpan={3}></td>
                        </tr>
                        <tr>
                            <th>DVmall 인증 DV ID</th>
                            <td colSpan={3}></td>
                        </tr>
                        <tr>
                            <th>덴탈비타민 ID</th>
                            <td>{data.memberId}</td>
                            <th className="border-l-ddd">
                                <button className="pick-address" onClick={handleIntegrated}>
                                    덴탈비타민ID로 통합
                                </button>
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="receive-infor">
                <div className="title-table-info">정보 수신</div>
                <table className="table member-infor">
                    <tbody>
                        <tr>
                            <th className="border-t-ddd border-b-ddd">
                                <span>덴탈비타민</span>
                            </th>
                            <td className="border-r-ddd border-b-ddd border-l-ddd">
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name="vitaminLetter"
                                        id="vitaminLetter"
                                        checked={data.vitaminLetter === 'Y'}
                                        onChange={handleUpdateVitaminLetter}
                                    />
                                </div>
                            </td>
                            <th className="border-t-ddd border-b-ddd">
                                <span>SMS</span>
                            </th>
                            <td className="border-b-ddd">
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name="smsSrv"
                                        id="smsSrv"
                                        checked={data.smsSrv === 'Y'}
                                        onChange={handleUpdateSMSSrv}
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="for-member-only">
                <div className="title-table-info">회원 대상</div>
                <table className="table member-infor">
                    <tbody>
                        <tr>
                            <th className="border-t-ddd border-b-ddd">
                                <span>우수회원선정</span>
                            </th>
                            <td colSpan={2} className="border-b-ddd">
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name="bcsSelYN"
                                        id="bcsSelYN"
                                        checked={data.bcsSelYN === 'Y'}
                                        onChange={handleUpdateBcsSelYN}
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="comments-member">
                <label htmlFor="commentArea" className="form-label">
                    <div className="title-table-info">코멘트</div>
                </label>
                <textarea
                    placeholder="내용을 입력하세요."
                    className="form-control"
                    id="commentArea"
                    rows={3}
                    name="comments"
                    onChange={handleInputChange}
                />
            </div>
            <div className="button-form" style={{ marginTop: '20px' }}>
                <button className="btn btn-primary" onClick={handleSaveComment}>
                    추가
                </button>
            </div>
            <div id="infomation-member">
                <label htmlFor="textarea1" className="form-label">
                    <div className="title-table-info">코멘트 리스트</div>
                </label>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>일자</th>
                            <th>관리자</th>
                            <th>내용</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataComments && dataComments.length > 0 ? (
                            dataComments.map((item, index) => (
                                <tr key={'comment' + index}>
                                    <td>{formatDate(item?.addDate)}</td>
                                    <td>{item?.adminName}</td>
                                    <td>{item?.comments}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td style={{ textAlign: 'center' }} colSpan={3}>
                                    데이타가 없습니다.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div className="bottom-content">
                <div className="button-form">
                    <Link to={'/mabaa010'} className="btn btn-primary button-back-to-list">
                        목록
                    </Link>
                </div>
                <div className="button-form">
                    <button className="btn btn-primary button-save" onClick={handleSave}>
                        저장
                    </button>
                </div>
            </div>
            {isPopupVisible && (
                <div id="popup" className="reason-popup">
                    <div className="overlay" onClick={handleClose} />
                    {isInputReason && (
                        <div className="popup-content">
                            <div className="popup-close" onClick={handleClose} />
                            <div className="popup-title">탈퇴사유</div>
                            <textarea className="reason" onChange={handleChangeReason} value={reasonValue}></textarea>
                            <div className="groupButton">
                                <Link to={'/mabaa010'} className="popup-button" onClick={handleSaveLeave}>
                                    탈퇴
                                </Link>
                                <Link className="popup-button" onClick={handleClose}>
                                    취소
                                </Link>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default MABAA031;
